'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/alertConfiguration/subscriber/staticSubscriber.html');
var twig = require('twig').twig;

module.exports = BaseStaticView.extend({
  template: twig({data: tpl}),
});
